module.exports = __webpack_public_path__ + "img/coin.f51f04d9.png";